"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["count"];
var ClientOrderListSkeleton = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var count = _ref.count,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledClientOrderListSkeleton, props, (0, _toConsumableArray2["default"])(Array(count)).map(function () {
    return /*#__PURE__*/_react["default"].createElement(StyledOrderSkeleton, null);
  }));
});
ClientOrderListSkeleton.displayName = 'ClientOrderListSkeleton';
ClientOrderListSkeleton.propTypes = {
  className: _propTypes["default"].string,
  count: _propTypes["default"].number
};
ClientOrderListSkeleton.defaultProps = {
  className: '',
  count: 2
};
var StyledClientOrderListSkeleton = _styledComponents["default"].div.withConfig({
  displayName: "ClientOrderListSkeleton__StyledClientOrderListSkeleton",
  componentId: "sc-as09ex-0"
})(["animation:fade 0.1s ease;@keyframes fade{from{opacity:0;}}"]);
var StyledOrderSkeleton = _styledComponents["default"].div.withConfig({
  displayName: "ClientOrderListSkeleton__StyledOrderSkeleton",
  componentId: "sc-as09ex-1"
})(["border-radius:7px;border:1px solid #c2c5cc;height:65px;margin-bottom:5px;width:100%;"]);
var _default = exports["default"] = ClientOrderListSkeleton;